import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Reportes/rvencimiento';
import Rvencimiento from './Rvencimiento';

const mstp = state => {
    return {...state.rvencimiento}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(Rvencimiento)
